import { twMerge } from "@/utils/twMerge";

export function SectionDivider({ className }: { className?: string }) {
  return (
    <div
      className={twMerge(
        "mx-1 h-px bg-block-border shadow-[0_1px_0_0_rgba(255,255,255,0.6)] dark:shadow-none",
        className,
      )}
    />
  );
}
